/**
 * Labstep
 *
 * @module components/Resource/Action/EditOrderRequestTemplate
 * @desc Action for editing item template
 */

import { ResourceOrderRequestTemplate as ResourceOrderRequestTemplateEdit } from 'labstep-web/components/Resource/OrderRequestTemplate';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { IResourceActionEditOrderRequestTemplateProps } from './types';

export const ResourceActionEditOrderRequestTemplate: React.FC<
  IResourceActionEditOrderRequestTemplateProps
> = ({ resource, actionComponentProps }) =>
  resource.is_template ? null : (
    <Modal
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          type="text"
          icon="copy"
          text="Edit Request Template"
          onClick={toggleModal}
          {...actionComponentProps}
        />
      )}
      content={
        <ResourceOrderRequestTemplateEdit resource={resource} />
      }
      size="large"
      closeOnDimmerClick
    />
  );
